import { PersonConnection } from "../../types/personConnection";
import {BaseConnectionService} from "./baseConnectionService";

class PersonConnectionService extends BaseConnectionService<PersonConnection> {
    constructor() {
        super("person-connections");
    }
}

export const personConnectionService = new PersonConnectionService();
